<div class="referral-wrapper">
  <p class="referral-link">Welcome to Lotto Social, great to have you onboard! We'll take you to sign up now</p>
</div>
